import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Button, Typography, Alert } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import persian_en from "react-date-object/locales/persian_en";
import DateObject from "react-date-object";
import useMediaQuery from "@mui/material/useMediaQuery";
import InputLabel from "@mui/material/InputLabel";
import moment from "moment";
import Divider from "@mui/material/Divider";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import Pagination from "@mui/material/Pagination";
import TablePagination from "@mui/material/TablePagination";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

// دیتاهای مورد نیاز و اسم نمایشی آنها را تعین میکند
const neededData = {
  marketingCode: "کد معرف",
  registrationsIds: "وضعیت",
  buyersIds: "تاریخ",
};
function createData(name, data) {
  return { name, data };
}

export default function ShowDetailsCode(props) {
  const detectSize600px = useMediaQuery("(min-width:600px)");

  const { handleCloseDialogContent, dataContent, getCodeDetails } = props;
  const [fetchedDataFromBack, setFetchedDataFromBack] = useState(false);
  //   let data = JSON.parse(dataContent);

  // هر مجموعه از دیتا را برای هر جدول درون یک المنت آرایه از listOfTable میریزد
  let listOfTable;
  useEffect(() => {
    getDataFromBack();
  }, []);
  const getDataFromBack = async () => {
    let recivedData = await getCodeDetails({ codeId: dataContent });
    setFetchedDataFromBack({
      buyersIds: recivedData["buyersIds"].length || 0,
      registrationsIds: recivedData["registrationsIds"].length || 0,
    });
  };

  const showRowData = (index, data) => {
    const { name, data: content } = data;
    return <StyledTableCell align="left">{content}</StyledTableCell>;
  };

  return (
    <>
      <DialogContent dividers>
        {!fetchedDataFromBack ? (
          "درحال دریافت اطلاعات ، لطفا صبر کنید"
        ) : (
          <TableContainer key={`MainTable-1`} component={Paper} sx={{ mb: 1 }}>
            <Table sx={{ minWidth: 10 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "25%" : "50%" }}
                  ></StyledTableCell>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "75%" : "50%" }}
                    align="left"
                  ></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    {"تعداد خرید"}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {`${fetchedDataFromBack.buyersIds} نفر`}
                  </StyledTableCell>
                </StyledTableRow>

                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    {"تعداد ثبت نام"}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    {`${fetchedDataFromBack.registrationsIds} نفر`}
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCloseDialogContent}>
          بستن
        </Button>
      </DialogActions>
    </>
  );
}
// import Button from "@mui/material/Button";
// import DialogContent from "@mui/material/DialogContent";
// import DialogActions from "@mui/material/DialogActions";
// import { Typography } from "@mui/material";

// export default function ShowStatus(props) {
//   const { handleCloseDialogContent, dataContent } = props;
//   let data = JSON.parse(dataContent);

//   return (
//     <>
//       <DialogContent dividers>
//         <Typography>test</Typography>
//       </DialogContent>
//       <DialogActions>
//         <Button autoFocus onClick={handleCloseDialogContent}>
//           بستن
//         </Button>
//       </DialogActions>
//     </>
//   );
// }
